import { createStyles, withStyles } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

export interface IDecorator {
  redux?: (state: any) => any;
  router?: boolean;
  styles?: (theme: any) => any;
}

// TODO pleace replace all `decorate` func with this one!
// decorateV2 just add types to `decorate`
export function decorateV2<T>(
  opts: IDecorator,
  comp: React.ComponentType<any>,
): React.ComponentType<T> {
  return decorate(opts, comp);
}

export function decorate(
  opts: IDecorator,
  comp: React.ComponentType<any>,
): React.ComponentType<any> {
  if (opts.styles) {
    comp = (
      withStyles(
        (theme: any) => {
          return createStyles((opts.styles as (theme: any) => { [key: string]: any })(theme));
        },
        {
          withTheme: true,
        },
      ) as any
    )(comp);
  }
  if (opts.redux) {
    comp = (connect(opts.redux) as any)(comp);
  }
  if (opts.router) {
    comp = (withRouter as any)(comp);
  }
  return comp;
}
